import { Action } from "redux";
import { OrganizationKeyName } from "../../../model/Organization";

export const GET_TAGS_FOR_ORGANIZATION_FAIL = "GET_TAGS_FOR_ORGANIZATION_FAIL";

export interface GetTagsForOrganizationFailAction extends Action {
  type: typeof GET_TAGS_FOR_ORGANIZATION_FAIL;
  organization: OrganizationKeyName;
}

export const getTagsForOrganizationFailAction = (
  organization: OrganizationKeyName
): GetTagsForOrganizationFailAction => ({
  type: GET_TAGS_FOR_ORGANIZATION_FAIL,
  organization,
});
